module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Guy Haley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A prolific freelance author and journalist, Guy Haley is the author of "), _c('I', [_vm._v("Reality 36, ")]), _vm._v("the Warhammer 40,000 novels "), _c('I', [_vm._v("Valedor ")]), _vm._v("and "), _c('I', [_vm._v("Baneblade")]), _vm._v(", among others. He lives in Yorkshire with his wife and son.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VnjcNx/tc-custom/9781466891975.jpg?1745278540261",
      "alt": "This image is the cover for the book Emperor's Railroad, The Dreaming Cities"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Emperor's Railroad, The Dreaming Cities\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('br'), _c('br'), _c('b', [_vm._v("A young boy and his mother meet an enigmatic knight in their journey through the ruins of American in this dark post-apocalyptic fantasy novella.")]), _c('br'), _c('br'), _c('b', [_vm._v("“Haley serves up equal helpings of horror, fantasy adventure, and SF in this stark, intriguing story of a ruined Earth where the remaining humans are determined to survive.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _c('br'), _c('br'), _vm._v("Global war devastated the environment, a zombie-like plague wiped out much of humanity, and civilization as we once understood it came to a standstill. But that was a thousand years ago, and the world is now a very different place."), _c('br'), _c('br'), _vm._v("Conflict between city-states is constant; superstition is rife; and machine relics, mutant creatures, and resurrected prehistoric beasts trouble the land. Watching over all are the silent Dreaming Cities: homes of the angels, bastion outposts of heaven on Earth. Or so the church claims. Very few go in, and nobody ever comes out."), _c('br'), _c('br'), _vm._v("Until now . . . "), _c('br'), _c('br'), _c('b', [_vm._v("“Entertaining and exciting . . . If grim-dark is your thing, then this is a great read for you.” —"), _c('i', [_vm._v("Bull-Spec")])]), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tor.com\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0